import { useFeature } from "../features";
import { useObjectMemo } from "../../../hooks";

import type { EnabledGlobalSearchEntities } from "../../../../types/Institution.types";

const DEFAULT_SEARCH_ENTITIES: EnabledGlobalSearchEntities = {
  accounts: true,
  cards: true,
  pages: true,
  transactions: true,
};

export const useIsGlobalSearchEnabled = () => {
  const { featureEnabled, features } = useFeature();

  return useObjectMemo({
    isSearchEnabled: featureEnabled("olb_global_search"),
    enabledSearchEntities:
      features?.olb_global_search_entities || DEFAULT_SEARCH_ENTITIES,
  });
};
